import React from 'react';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import { useLang } from '../context/LangContext';

interface AdditionalInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToAdditionalInfo: () => void;
}

const additionalInfoTexts = {
  ko: {
    header: '추가 정보 입력이 필요합니다',
    body: '서비스 이용을위해 추가정보가 필요합니다\n추가 정보를 입력해 주세요.',
    buttonText: '추가 정보 입력하기'
  },
  en: {
    header: 'Additional Information Required',
    body: 'Additional information is required to use the service.\nPlease enter the additional information.',
    buttonText: 'Enter Additional Information'
  }
};

const AdditionalInfoModal: React.FC<AdditionalInfoModalProps> = ({
  isOpen,
  onClose,
  onGoToAdditionalInfo
}) => {
  const { lang } = useLang();
  const texts = additionalInfoTexts[lang];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={texts.header}
      bgColor="white"
      body={texts.body}
      footer={
        <PrimaryButton onClick={onGoToAdditionalInfo}>
          {texts.buttonText}
        </PrimaryButton>
      }
    />
  );
};

export default AdditionalInfoModal;